import portfolioData from '@/data/portfolio.json';
import { Project, PortfolioData } from '@/types/portfolio';

export const getPortfolioData = (): PortfolioData => {
  return portfolioData as PortfolioData;
};

export const getProjects = (): Project[] => {
  return portfolioData.projects;
};

export const getFeaturedProjects = (): Project[] => {
  return portfolioData.projects.filter(project => project.featured);
};

export const getProjectsByCategory = (category: string): Project[] => {
  if (category === 'all') {
    return portfolioData.projects;
  }
  return portfolioData.projects.filter(project => project.category === category);
};

export const getProjectById = (id: string): Project | undefined => {
  return portfolioData.projects.find(project => project.id === id);
};

export const getCategories = (): { [key: string]: string } => {
  return portfolioData.categories;
};

export const getRecentProjects = (limit: number = 3): Project[] => {
  return [...portfolioData.projects]
    .sort((a, b) => (b.views || 0) - (a.views || 0))
    .slice(0, limit);
};